<template>
    <div class="site-width uk-animation-fade single">
        <Seo canonical="/charity-runs" title="Charity Runs" />

        <div class="menu-headline-distance" />

        <SiteHeadline
            is-main
            switch-headline
            headline="Jeder Schritt zählt."
            message="Melde dich jetzt für einen unserer Charity Runs an und unterstütze die Kinderkrebsforschung." />

        <div class="headline-message-distance" />

        <!-- Loading -->
        <div v-if="loading" class="uk-text-center">
            <div uk-spinner />
        </div>

        <!-- Empty -->
        <div
            v-else-if="events.length === 0"
            class="uk-text-center uk-margin-large-top">
            <p style="opacity: 0.5">
                Aktuell sind keine Charity Runs zur Anmeldung verfügbar.
            </p>
        </div>

        <!-- Events -->
        <div v-else class="events-grid">
            <div
                v-for="event in events"
                :key="event.slug"
                class="event-card uk-card uk-card-alternative uk-padding-small">
                <div v-if="event.supporter_logo" class="event-logo-wrap">
                    <img
                        :src="event.supporter_logo"
                        :alt="event.name"
                        class="event-logo" />
                </div>
                <div class="event-name">{{ event.name }}</div>
                <div class="event-meta">
                    <div class="event-meta-row">
                        <span>📅</span>
                        <span>{{ event.event_date }}</span>
                    </div>
                    <div v-if="event.location" class="event-meta-row">
                        <span>📍</span>
                        <span>{{ event.location }}</span>
                    </div>
                </div>
                <div
                    v-if="event.distances && event.distances.length"
                    class="distances-row">
                    <span
                        v-for="d in event.distances"
                        :key="d.value"
                        class="distance-pill">
                        {{ formatDistance(d.value) }} km
                    </span>
                </div>
                <router-link
                    :to="'/' + $i18n.locale + '/charity-run/' + event.slug"
                    class="btn-register">
                    Jetzt Anmelden →
                </router-link>
            </div>
        </div>

        <div class="uk-margin-large-top" />
    </div>
</template>

<script>
import Seo from '../../components/Seo.vue';
import SiteHeadline from '@/components/SiteHeadline.vue';
import axios from 'axios';

export default {
    name: 'CharityRuns',
    components: {Seo, SiteHeadline},
    data() {
        return {
            loading: true,
            events: [],
        };
    },
    created() {
        this.loadEvents();
    },
    methods: {
        loadEvents() {
            axios
                .get(this.getBaseUrl + '/api/charity-runs')
                .then((res) => {
                    this.events = res.data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        formatDistance(val) {
            return String(val).replace('.', ',');
        },
    },
};
</script>

<style lang="scss" scoped>
.events-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;

    @media (max-width: 640px) {
        grid-template-columns: 1fr;
    }
}

.event-card {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.event-logo-wrap {
}

.event-logo {
    max-height: 32px;
    max-width: 120px;
    object-fit: contain;
    opacity: 0.85;
}

.event-name {
    font-size: 1.1rem;
    font-weight: 700;
    color: #fff;
}

.event-meta {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.event-meta-row {
    display: flex;
    gap: 8px;
    font-size: 13px;
    opacity: 0.75;
}

.distances-row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.distance-pill {
    display: inline-block;
    background: #1e1e26;
    border: 1px solid #333;
    border-radius: 20px;
    padding: 2px 10px;
    font-size: 12px;
    font-weight: 700;
    color: #3ddc97;
}

.btn-register {
    display: inline-block;
    background: #3ddc97;
    color: #121217 !important;
    padding: 10px 20px;
    border-radius: 50px;
    font-size: 13px;
    font-weight: 700;
    text-decoration: none !important;
    margin-top: auto;
    transition: background 0.2s;
    text-align: center;
    &:hover {
        background: #2cb87e;
    }
}
</style>

